// extracted by mini-css-extract-plugin
export default {"container":"NmiApplePayButton_container__iLV4-"};